import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableBadge = ({
  use = 'new',
  translationKey = 'RECOMMENDED'
}) => {
  return /*#__PURE__*/_jsx(Badge, {
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages-ui.merchCardsV2.badges.${translationKey}`
    })
  });
};
export default FeatureTableBadge;